export const regulatorRouteNames = {
  DASHBOARD: { name: 'REGULATOR_MY_CAMPAIGNS' },
  MY_CAMPAIGNS: { name: 'REGULATOR_MY_CAMPAIGNS' },
  PLAYLIST: { name: 'REGULATOR_PLAYLIST' },
  MY_CAMPAIGN_VIEW: { name: 'REGULATOR_MY_CAMPAIGN_VIEW' },
  MY_CAMPAIGN_DETAILS: { name: 'MY_CAMPAIGN_DETAILS' },
};
